export const GET_CONSUMER_TICKETS = "GET_CONSUMER_TICKETS";
export const SET_CONSUMER_TICKETS = "SET_CONSUMER_TICKETS";

export const API_ERROR = "CONSUMER_TICKETS_API_ERROR";
